module.exports = __webpack_public_path__ + "static/img/bloom-icon-128px.293045f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bloom-icon-128px.png
// module id = b1Gk
// module chunks = 1